import * as React from 'react';
import { useSelector } from 'react-redux';

import { ChatHeaderOffer } from '../../components/ChatHeader';
import { offerSelector } from '../../selectors';

export const ChatHeaderOfferContainer: React.FC = () => {
  const offer = useSelector(offerSelector);

  if (!offer) {
    return null;
  }

  return <ChatHeaderOffer offer={offer} />;
};
